import { apiBase, authHeaders } from "./auth";

function parseError(res, data) {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return `Erro ${res.status}`;
}

/**
 * @param {number} id_entity_company
 * @returns {Promise<{ id_entity_company: number, nm_entity: string }>}
 */
export async function setActiveCompanyRequest(id_entity_company) {
  const res = await fetch(`${apiBase()}/sca/context/active`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ id_entity_company }),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    throw new Error(parseError(res, data));
  }
  return data;
}
